<!--
 * @Author: Jacob.Zhang
 * @Description: 客户端 - 引导页
-->
<template>
    <div class="guide-box">
        <div v-loading="isLoading" class="guide-content">
            <div class="guide-bg">
                <img :src="readyPage === 1 ? guide1 : guide2">
                <i class="el-icon-close close-btn" @click="confirm" />
            </div>
            <div class="word-content">
                <!-- 第一页 -->
                <template v-if="readyPage === 1">
                    <p>您好！欢迎来到澳门优才申请系统，请按照<strong>实际情况</strong>填写；</p>
                    <p>1.如您填写途中想离开系统，可以<strong>点击下方的保存，</strong>在您有空闲的时间再继续进行填写；</p>
                    <p>2.此次填写将花费您<strong>30-40分钟，</strong>系统将根据您所填写的信息，<strong>形成详细资料清单</strong>，一起为澳门身份起航吧~</p>
                </template>
                <!-- 第二页 -->
                <template v-if="readyPage === 2">
                    <p>您也可以事先准备您自己、配偶及子女（如有）的材料在<strong>电脑中</strong>，系统会自动识别信息填写，可为您<strong>节省40%</strong>的信息填写时间；</p>
                    <p><strong>准备材料：</strong></p>
                    <div class="check-info">
                        <span><i class="el-icon-check"></i>身份证正反面照片</span>
                        <span><i class="el-icon-check"></i>护照（如有）</span>
                        <span><i class="el-icon-check"></i>港澳通行证正反面照片</span>
                        <span><i class="el-icon-check"></i>简历/工作总结</span>
                    </div>
                </template>
                <div class="btn">
                    <span class="next-btn" @click="confirm">{{ readyPage === 2 ? "我已准备就绪，开始填写" : "下一步" }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import guide1 from '@/assets/img/guide/gifted1.png'
import guide2 from '@/assets/img/guide/gifted2.png'
import { setKey } from '../../api/gifted'
export default {
    name: "MacaoGiftedGuide",
    props: {
        isReady: {
            type: Number,
            default: null
        },
        readyPage: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            isLoading: false,
            guide1,
            guide2,
        }
    },
    created() {
        document.querySelector('body').classList.add("modal")
    },
    beforeDestroy() {
        document.querySelector('body').classList.remove("modal")
    },
    methods: {
        confirm() {
            // 第2页为最后一页，需要改变状态 不需要改变页码
            this.readyPage === 2 ? this.readInfo(1, this.readyPage) : this.readInfo(this.isReady, this.readyPage + 1)
        },

        /**
         * @description 保存阅读状态
         * @param {isReady} 是否阅读完 0否1是
         * @param {readyPage} 阅读到第几页
         */
        async readInfo(isReady, readyPage) {
            try {
                this.isLoading = true
                await setKey({
                    key: this.$store.state.gifted.user.userId,
                    value: JSON.stringify({ isReady, readyPage })
                })
                // 判断阅读状态
                isReady === 1 ? this.$emit('update:isReady', 1) : this.$emit('update:readyPage', readyPage)
            } catch (error) {
                console.log(error)
            } finally {
                this.isLoading = false
            }
        }
    },
}
</script>

<style lang="less" scoped>
.guide-box {
    z-index: 2005;
    background-color: rgba(0,0,0,.4);
    position: fixed;
    overflow: auto;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .guide-content {
        border-radius: 15px;
        width: 1070px;
        margin: 10vh auto 50px;
        background-color: #fff;
        .guide-bg {
            position: relative;
            img {
                vertical-align: middle;
                width: 100%;
            }
            .close-btn {
                cursor: pointer;
                position: absolute;
                right: 20px;
                top: 20px;
                color: #fff;
                font-size: 32px;
                transition: .5s;
                &:hover {
                    transform: rotate(180deg);
                }
            }
        }
        .word-content {
            font-size: 24px;
            padding: 30px 65px;
            p {
                margin-bottom: 30px;
            }
            .btn {
                text-align: center;
                span.next-btn {
                    cursor: pointer;
                    display: inline-block;
                    border-radius: 5px;
                    color: #fff;
                    background-color: #009efe;
                    padding: 10px 40px;
                    font-size: 24px;
                    transition: .1s;
                    &:hover {
                        opacity: .8;
                    }
                }
            }
            .check-info {
                margin-bottom: 35px;
                display: flex;
                justify-content: space-between;
                i {
                    font-weight: bold;
                    color: #009efe;
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>
